import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OmniSharedUiModule } from '@cigna/omni/shared';
import { OmniConversationsStateModule } from '@cigna/omni/conversations-state';
import { OmniFancyInvitationsStateModule } from '@cigna/omni/fancy-invitations-state';
import { FancyInvitationComponent } from './fancy-invitation/fancy-invitation.component';
import { FancyInvitationsDataComponent } from './fancy-invitations-data/fancy-invitations-data.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    OmniSharedUiModule,
    OmniConversationsStateModule,
    OmniFancyInvitationsStateModule,
  ],
  declarations: [FancyInvitationComponent, FancyInvitationsDataComponent],
  exports: [FancyInvitationsDataComponent],
})
export class OmniFancyInvitationsModule {}
